module.exports = __webpack_public_path__ + "static/media/10.85b94a20.jpg";